// We need to initialize common page elements,
// as this entrypoint isn't initialized by the main application.js
import "entry/common"
import { addCSRFTokenToAjaxRequestsWithSession } from "lib/csrfAjaxPrefilter"

import $ from "jquery"
import { isSessionActive } from "lib/currentUser/session"
import {
  getWindowLocationPathname,
  navigateWindowLocation,
} from "@theconversation/shared-libraries/windowLocation"
import { initializeCommonPageElements } from "pages/common"
import Stimulus from "stimulus_init"
import TabsController from "controllers/tabs_controller"

const showMoreExperts = (event) => {
  event.preventDefault()
  $(".expert-authors").addClass("show-all")
}

const setTopicFollowedState = (following) => {
  $(".actions .follow-link")
    .toggleClass("followed", following)
    .toggleClass("not-followed", !following)
}

let followStateRequest = null

const fetchTopicFollowedState = () => {
  followStateRequest = $.ajax({
    type: "GET",
    url: `${document.location.pathname}/following`,
    success: ({ following }) => setTopicFollowedState(following),
    failure: () => setTopicFollowedState(false),
  })
}

const toggleTopicFollow = (following) => (event) => {
  event.preventDefault()
  followStateRequest?.abort?.()
  $.ajax({
    type: "POST",
    url: $(event.currentTarget).data("url"),
    success: () => setTopicFollowedState(following),
    error: fetchTopicFollowedState,
  })
}

const initializeExpertEvents = () => {
  $(".expert-authors .more a").on("click", showMoreExperts)
}

const initializeFollowEvents = () => {
  if (!isSessionActive()) {
    $(".actions .follow-link button").on("click", (event) => {
      event.preventDefault()
      navigateWindowLocation(
        `/sign_in?return_to=${encodeURIComponent(getWindowLocationPathname())}`,
      )
    })
    setTopicFollowedState(false)
    return
  }

  fetchTopicFollowedState()
  $(".actions .follow-link .follow").on("click", toggleTopicFollow(true))
  $(".actions .follow-link .unfollow").on("click", toggleTopicFollow(false))
}

Stimulus.register("tabs", TabsController)

addCSRFTokenToAjaxRequestsWithSession()

async function initialize() {
  initializeCommonPageElements()
  initializeExpertEvents()
  initializeFollowEvents()
}

TC.EntrypointInitializer = initialize
